import { buildRequestUrlToFetchTaxonomyData } from "./buildRequestUrlToFetchTaxonomyData";

export { buildRequestUrlToFetchTaxonomyData };
